export var Labels = {
    useHomeAsBillingAddress: 'My billing address is the same as the address on my plan',
    addressLine1: 'ที่อยู่ในการส่งใบเสร็จ/ใบแจ้งหนี้ของธนาคาร',
    addressLine2: 'ที่อยู่เพิ่มเติม (ระบุหรือไม่ก็ได้)',
    city: 'เขต/อำเภอ',
    state: 'จังหวัด',
    zipCode: 'รหัสไปรษณีย์'
};
export var FieldErrors = {
    invalidAddressLine1: 'กรุณาใส่ที่อยู่ให้ถูกต้อง',
    invalidCity: 'กรุณาใส่เขต/อำเภอที่ถูกต้อง',
    invalidState: 'กรุณาใส่จังหวัดที่ถูกต้อง',
    invalidZipCode: 'กรุณาใส่รหัสไปรษณีย์ที่ถูกต้อง'
};
export { States } from '../en-TH/billingAddress';
